import { createAction } from 'redux-actions';
import { COPY2PAYLOAD, GENERATOR, SILENT } from 'uix/actions';
export let getChildren = createAction('GET_TREE_CHILDREN', ({ otid, odid, typeName, stateNames, idContext, rootFolder, descendants = false, subdomains = false, deleted = true, links = true })=>({
        otid,
        odid,
        typeName,
        stateNames,
        idContext,
        rootFolder,
        deleted,
        descendants,
        subdomains,
        links
    }), SILENT);
// XXX: unused
export const fetchDescendants = createAction('FETCH_TREE_DESCENDANTS', (node, typeNames)=>({
        node,
        typeNames
    }));
export const setDescendants = createAction('SET_TREE_DESCENDANTS', (node, data, typeNames)=>({
        node,
        data,
        typeNames
    }));
export let getTreeDetails = createAction('GET_TREE_DETAILS', (otid, datatype)=>({
        otid,
        datatype
    }), SILENT);
export let setTreeDetails = createAction('SET_TREE_DETAILS', (data)=>({
        data
    }));
export let setTreeDetailsErrors = createAction('SET_TREE_DETAILS_ERRORS', (loadFailures)=>({
        loadFailures
    }));
export let setTreeChildren = createAction('SET_TREE_CHILDREN', (otid, data, idContext, refreshParams)=>({
        otid,
        data,
        idContext,
        refreshParams
    }), GENERATOR('treeDataVersion'));
// update tree.byId for a single tree node with derived data (probably from ancestorAxis)
export let setTreeNodeData = createAction('SET_TREE_NODE_DATA', (otid, odid, caption, datatype, subtype, delstate = false)=>({
        otid,
        odid,
        caption,
        datatype,
        subtype
    }));
// as setTreeNodeData, but for many records (api/treeList)
export let setTreeNodesData = createAction('SET_TREE_NODES_DATA', (data)=>({
        data
    }), GENERATOR('treeDataVersion'));
// fill/refresh data.tree.byId
export let getTreeNodes = createAction('GET_TREE_NODES', (otids)=>({
        otids
    }));
export let clearTree = createAction('CLEAR_TREE');
// wrap standard go with throttle saga effect
export let goTree = createAction('GO_TREE', COPY2PAYLOAD, SILENT);
export let getAvailableTypes = createAction('GET_AVAILABLE_TYPES', (dname)=>({
        dname
    }));
export let setAvailableTypes = createAction('SET_AVAILABLE_TYPES', COPY2PAYLOAD, GENERATOR('treeDataVersion'));
export let getAvailableStates = createAction('GET_AVAILABLE_STATES', (dname, statusType)=>({
        dname,
        statusType
    }));
export let setAvailableStates = createAction('SET_AVAILABLE_STATES', COPY2PAYLOAD, GENERATOR('treeDataVersion'));
export const getDelivererYears = createAction('GET_DELIVERER_YEARS', COPY2PAYLOAD);
export const setDelivererYears = createAction('SET_DELIVERER_YEARS', COPY2PAYLOAD);
export const getDelivererYearMds = createAction('GET_DELIVERER_YEAR_MDS', COPY2PAYLOAD);
export const setDelivererYearMds = createAction('SET_DELIVERER_YEAR_MDS', COPY2PAYLOAD);
// make a copy of node - VTree._index mutates expansion state of tree nodes
// this will trigger redux-freeze if such nodes are copied into store
export const setActiveTreeNode = createAction('SET_ACTIVE_TREE_NODE', (node)=>({
        node: {
            ...node
        }
    }));
export const setTreeSelection = createAction('SET_TREE_SELECTION', (nodes)=>({
        nodes: nodes.map((node)=>{
            let { children, ...safeNode } = node;
            return safeNode;
        })
    }));
export const setTreeChildrenLoading = createAction('SET_TREE_CHILDREN_LOADING', (hash, value)=>({
        hash,
        value
    }), SILENT);
//~ export const setTreeChildrenActive = createAction(
//~ 'SET_CHILDREN_ACTIVE',
//~ (idContext, otid, getChildrenParams) => ({idContext, otid, getChildrenParams}),
//~ // SILENT
//~ )
export const switchTabGroup = createAction('SWITCH_TAB_GROUP', (nodeType, group, classname, tabname)=>({
        nodeType,
        group,
        classname,
        tabname
    }));
export const switchTopTab = createAction('SWITCH_TOP_TAB', (classname, tabname, group, minorTabGroup)=>({
        classname,
        tabname,
        group,
        minorTabGroup
    }));
export const pinTreeNode = createAction('PIN_TREE_NODE', (otid, isPinned = true)=>({
        otid,
        isPinned
    }));
export const clearTreePinned = createAction('CLEAR_TREE_PINNED');
export const deleteTreeRecords = createAction('DELETE_TREE_RECORDS', ({ otid, otids, erase, onDeleted })=>({
        otid,
        otids,
        erase,
        onDeleted
    }));
export const editTreeCaption = createAction('EDIT_TREE_CAPTION', ({ otid, caption, old })=>({
        otid,
        caption,
        old
    }));
export const fetchAncestorAxisChildren = createAction('FETCH_ANCESTOR_AXIS_CHILDREN', ({ ancestorAxis, ctxid, routeDeletedToPaperbin })=>({
        ancestorAxis,
        ctxid,
        ...routeDeletedToPaperbin ? {
            routeDeletedToPaperbin
        } : {}
    }), SILENT);
